(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-brand-mini"]) return;
  try {
    
(function () {
  var strip = document.querySelector('[data-cbm-strip]');
  if (!strip) return;
  // Drag-to-scroll only matters when it actually overflows (mobile/tablet).
  var down = false, sx = 0, sl = 0, moved = false;
  strip.addEventListener('mousedown', function (e) {
    down = true; moved = false; sx = e.pageX; sl = strip.scrollLeft;
    strip.classList.add('is-dragging'); e.preventDefault();
  });
  window.addEventListener('mouseup', function () { down = false; strip.classList.remove('is-dragging'); });
  window.addEventListener('mousemove', function (e) {
    if (!down) return; var dx = e.pageX - sx; if (Math.abs(dx) > 3) moved = true; strip.scrollLeft = sl - dx;
  });
  strip.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  function end() {
    var atEnd = strip.scrollLeft >= (strip.scrollWidth - strip.clientWidth - 2);
    strip.classList.toggle('is-scroll-end', atEnd || strip.scrollWidth <= strip.clientWidth + 2);
  }
  strip.addEventListener('scroll', end, { passive: true }); window.addEventListener('resize', end); end();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function toggle(header, open) {
    var panel = header.nextElementSibling;
    if (!panel) return;
    var isOpen = header.getAttribute('aria-expanded') === 'true';
    if (typeof open === 'boolean') { if (open === isOpen) return; } else { open = !isOpen; }
    header.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.style.maxHeight = open ? (panel.scrollHeight + 'px') : '0px';
  }
  document.querySelectorAll('.ct-acc-header').forEach(function (header) {
    header.addEventListener('click', function () { toggle(header); });
  });
  // Keep open panels correctly sized on resize.
  window.addEventListener('resize', function () {
    document.querySelectorAll('.ct-acc-header[aria-expanded="true"]').forEach(function (h) {
      var p = h.nextElementSibling;
      if (p) p.style.maxHeight = p.scrollHeight + 'px';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KEY = 'rw_recently_viewed';
  var section = document.querySelector('[data-recently-viewed]');
  if (!section) return;

  var current = section.getAttribute('data-current-handle') || '';
  var designMode = section.getAttribute('data-design-mode') === 'true';

  // Always record the current product view.
  if (current) {
    try {
      var stored = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(stored)) stored = [];
      stored = stored.filter(function (h) { return h && h !== current; });
      stored.unshift(current);
      localStorage.setItem(KEY, JSON.stringify(stored.slice(0, 20)));
    } catch (e) {}
  }

  function setupCarousel() {
    var track = section.querySelector('[data-recently-viewed-grid]');
    var prev = section.querySelector('[data-rv-prev]');
    var next = section.querySelector('[data-rv-next]');
    if (!track || !prev || !next) return;

    function update() {
      var overflow = (track.scrollWidth - track.clientWidth) > 4;
      if (!overflow) { prev.hidden = true; next.hidden = true; return; }
      // Hide (not just disable) an arrow that can't do anything.
      prev.hidden = track.scrollLeft <= 2;
      next.hidden = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 2);
    }
    function step(dir) {
      var card = track.querySelector('.product-item');
      var amount = card ? (card.getBoundingClientRect().width + 16) * 2 : track.clientWidth * 0.8;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var target = Math.max(0, Math.min(track.scrollLeft + dir * amount, maxScroll));
      // Direct assignment scrolls reliably everywhere (native smooth-scroll is unreliable
      // inside a scroll-snap container).
      track.scrollLeft = target;
      update();
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // In the theme editor, keep the server-rendered placeholder cards.
  if (designMode) {
    setupCarousel();
    return;
  }

  var grid = section.querySelector('[data-recently-viewed-grid]');
  var max = parseInt(section.getAttribute('data-max'), 10) || 12;

  var handles;
  try { handles = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { handles = []; }
  if (!Array.isArray(handles)) handles = [];
  handles = handles.filter(function (h) { return h && h !== current; }).slice(0, max);
  if (!handles.length || !grid) return; // section stays hidden

  Promise.all(handles.map(function (h) {
    return fetch('/products/' + encodeURIComponent(h) + '?view=card', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
  })).then(function (parts) {
    var html = parts.join('').trim();
    if (!html) return;
    grid.innerHTML = html;
    section.hidden = false;

    // Injected images are lazy + hidden-until-loaded, so the lazy observer never
    // fires on them. Force eager loading to break that deadlock (their inline
    // onload adds the '.loaded' class that reveals the image).
    grid.querySelectorAll('img').forEach(function (img) {
      img.loading = 'eager';
      var src = img.getAttribute('src');
      if (src && (!img.complete || !img.naturalWidth)) img.src = src;
      var wrap = img.closest('.image');
      if (wrap && img.complete && img.naturalWidth) wrap.classList.add('loaded');
    });

    setupCarousel();

    // Let theme/app card behaviours (wishlist) re-bind to injected cards.
    try {
      document.dispatchEvent(new CustomEvent('rw:recently-viewed:loaded', { detail: { container: grid } }));
    } catch (e) {}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-balls"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('[data-related-balls]');
  if (!section) return;
  var track = section.querySelector('[data-rball-track]');
  var prev = section.querySelector('[data-rball-prev]');
  var next = section.querySelector('[data-rball-next]');
  if (!track || !prev || !next) return;

  track.querySelectorAll('img').forEach(function (img) {
    img.loading = 'eager';
    var src = img.getAttribute('src');
    if (src && (!img.complete || !img.naturalWidth)) img.src = src;
    var wrap = img.closest('.image');
    if (wrap && img.complete && img.naturalWidth) wrap.classList.add('loaded');
  });

  function update() {
    var overflow = (track.scrollWidth - track.clientWidth) > 4;
    if (!overflow) { prev.hidden = true; next.hidden = true; return; }
    prev.hidden = track.scrollLeft <= 2;
    next.hidden = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 2);
  }
  function step(dir) {
    var card = Array.prototype.find.call(track.querySelectorAll('.rball-card'), function (c) { return c.offsetWidth > 0; });
    var amount = card ? (card.getBoundingClientRect().width + 14) * 2 : track.clientWidth * 0.8;
    var maxScroll = track.scrollWidth - track.clientWidth;
    track.scrollLeft = Math.max(0, Math.min(track.scrollLeft + dir * amount, maxScroll));
    update();
  }
  var tabs = section.querySelectorAll('[data-rball-tab]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var g = tab.getAttribute('data-rball-tab');
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      track.querySelectorAll('.rball-card').forEach(function (card) {
        card.style.display = card.getAttribute('data-rball-group') === g ? '' : 'none';
      });
      track.scrollLeft = 0;
      update();
    });
  });
  prev.addEventListener('click', function () { step(-1); });
  next.addEventListener('click', function () { step(1); });
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-brand"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('[data-related-brand]');
  if (!section) return;
  var track = section.querySelector('[data-rb-track]');

  // Force-load lazy images so the injected/hidden-until-loaded cards actually show.
  section.querySelectorAll('img').forEach(function (img) {
    img.loading = 'eager';
    var src = img.getAttribute('src');
    if (src && (!img.complete || !img.naturalWidth)) img.src = src;
    var wrap = img.closest('.image');
    if (wrap && img.complete && img.naturalWidth) wrap.classList.add('loaded');
  });

  // Everything below is for the single-carousel layout only.
  var prev = section.querySelector('[data-rb-prev]');
  var next = section.querySelector('[data-rb-next]');
  if (!track || !prev || !next) return;

  function update() {
    var overflow = (track.scrollWidth - track.clientWidth) > 4;
    if (!overflow) { prev.hidden = true; next.hidden = true; return; }
    prev.hidden = track.scrollLeft <= 2;
    next.hidden = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 2);
  }
  function step(dir) {
    var card = track.querySelector('.rb-card');
    var amount = card ? (card.getBoundingClientRect().width + 14) * 2 : track.clientWidth * 0.8;
    var maxScroll = track.scrollWidth - track.clientWidth;
    track.scrollLeft = Math.max(0, Math.min(track.scrollLeft + dir * amount, maxScroll));
    update();
  }
  prev.addEventListener('click', function () { step(-1); });
  next.addEventListener('click', function () { step(1); });
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);

  // --- Sort tabs: reorder the cards by the chosen field ---
  var tabs = section.querySelectorAll('[data-rb-sort]');
  var priceAsc = true;

  // --- Bestsellers: real sales order, fetched on first use ---
  // Shopify will sort any collection best-selling on request (?sort_by=best-selling), even
  // one whose own default sort is newest-first, so collection pages keep their order and this
  // still gets sales order. sections/rb-bestseller-order.liquid returns just the product IDs
  // in that order via the Section Rendering API. data-rb-bs-url is the collection the row was
  // built from (the brand collection, or the sport one when the row was widened), so every
  // card is in the list. One small request, only when someone picks Bestsellers, then cached.
  var bsRanks = null;
  function loadBestsellerRanks() {
    if (bsRanks) return bsRanks;
    var base = section.getAttribute('data-rb-bs-url');
    if (!base) return (bsRanks = Promise.resolve());
    var url = base + (base.indexOf('?') === -1 ? '?' : '&') + 'sort_by=best-selling&section_id=rb-bestseller-order';
    bsRanks = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-rb-bs-order]');
        var ids = node ? JSON.parse(node.textContent || '[]') : [];
        var rank = {};
        ids.forEach(function (id, i) { rank[String(id)] = i + 1; });
        track.querySelectorAll('.rb-card').forEach(function (card) {
          var r = rank[card.getAttribute('data-product-id')];
          if (r) card.setAttribute('data-rank', r);
        });
      })
      .catch(function () {});
    return bsRanks;
  }

  function sortCards(mode) {
    var cards = Array.prototype.slice.call(track.querySelectorAll('.rb-card'));
    cards.sort(function (a, b) {
      if (mode === 'price') {
        var pa = parseInt(a.dataset.price, 10) || 0, pb = parseInt(b.dataset.price, 10) || 0;
        return priceAsc ? pa - pb : pb - pa;
      }
      if (mode === 'rank') {
        // 9999 = not in the fetched best-selling list (below its first 50, or the request
        // failed); those keep their built order.
        var ra = parseInt(a.dataset.rank, 10) || 9999, rb = parseInt(b.dataset.rank, 10) || 9999;
        return (ra - rb) || ((parseInt(a.dataset.pos, 10) || 0) - (parseInt(b.dataset.pos, 10) || 0));
      }
      return (parseInt(b.dataset.created, 10) || 0) - (parseInt(a.dataset.created, 10) || 0);
    });
    cards.forEach(function (c) { track.appendChild(c); });
    track.scrollLeft = 0;
    update();
  }
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var mode = tab.getAttribute('data-rb-sort');
      if (mode === 'price' && tab.classList.contains('is-active')) priceAsc = !priceAsc;
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      // The arrow belongs to the price sort only. Left on the tab after switching away, it
      // read as though the row were still sorted by price ("Bestsellers" active beside
      // "Price ↓"). Reset it, and restart at low-to-high next time Price is picked.
      var priceTab = section.querySelector('[data-rb-sort="price"]');
      if (mode === 'price') {
        tab.textContent = priceAsc ? 'Price ↑' : 'Price ↓';
      } else if (priceTab) {
        priceTab.textContent = 'Price';
        priceAsc = true;
      }
      if (mode === 'rank') {
        loadBestsellerRanks().then(function () {
          // Only apply if Bestsellers is still the chosen tab when the order arrives.
          if (tab.classList.contains('is-active')) sortCards('rank');
        });
      } else {
        sortCards(mode);
      }
    });
  });

  // --- Gender pills (shoes only): filter cards by gender ---
  var genderBtns = section.querySelectorAll('[data-rb-gender]');
  genderBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var g = btn.getAttribute('data-rb-gender');
      genderBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      track.querySelectorAll('.rb-card').forEach(function (card) {
        var cg = card.getAttribute('data-gender') || '';
        // Opposite gender is hidden; unisex/unknown always show.
        var show = (g === 'all') || (cg === g) || (cg === 'unisex') || (cg === '');
        card.style.display = show ? '' : 'none';
      });
      track.scrollLeft = 0;
      update();
    });
  });

  // --- Sport tabs (clothing/accessory pages showing the brand's rackets) ---
  // One sport at a time; "View all" follows the chosen sport.
  var sportBtns = section.querySelectorAll('[data-rb-sport]');
  var viewAll = section.querySelector('.related-brand__viewall');
  sportBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var s = btn.getAttribute('data-rb-sport');
      sportBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      track.querySelectorAll('.rb-card').forEach(function (card) {
        card.style.display = card.getAttribute('data-sport') === s ? '' : 'none';
      });
      var url = btn.getAttribute('data-rb-url');
      if (viewAll) {
        if (url) { viewAll.setAttribute('href', url); viewAll.hidden = false; } else { viewAll.hidden = true; }
      }
      track.scrollLeft = 0;
      update();
    });
  });

  sortCards('new');
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-social-reels]');
  if (!root) return;
  root.querySelectorAll('.social-reels__tile').forEach(function (tile) {
    var v = tile.querySelector('.social-reels__video');
    if (!v) return;
    v.muted = true; v.loop = true; v.playsInline = true;
    tile.addEventListener('mouseenter', function () {
      if (v.preload === 'none') v.preload = 'auto';
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
    tile.addEventListener('mouseleave', function () {
      v.pause();
      try { v.currentTime = 0; } catch (e) {}
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
